/* CREATE FLOW 1:1 with customsolo-made-for-love.pages.dev — 2026-09-16 */
(function (root, factory) {
  const gallery = factory();
  if (typeof module === 'object' && module.exports) module.exports = gallery;
  else { root.CustomsoloCollectionGallery = gallery; gallery.init(root.document); }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const nextIndex = (index, delta, count) => Math.max(0, Math.min(count - 1, index + delta));
  const swipeDelta = (dx, dy) => Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25 ? (dx < 0 ? 1 : -1) : 0;

  function init(doc, scope = doc) {
    scope.querySelectorAll('[data-card-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const card = gallery.closest('.customsolo-d01-card');
      // Curated preview merchandising flags; stable across sorting and pagination.
      const newProducts=new Set(['SP00278','SP04934','SP00971','SP04238','SP07092','SP07125','SP07223','SP07036','memory-ornament','memory-light','home-memory-cube','family-gift-photo-mug','family-gift-heart-ornament','family-gift-photo-cube','family-gift-photo-slate','family-gift-photo-tote']);
      const badge=doc.createElement('span');badge.className='customsolo-card-new';
      if(newProducts.has(card.dataset.productCard||card.dataset.productId)){badge.textContent='New';card.dataset.merchandisingNew='true';}
      else badge.setAttribute('aria-hidden','true');
      card.querySelector('.customsolo-d01-card__content')?.prepend(badge);
      const track = gallery.querySelector('.customsolo-d01-gallery__track');
      const slides = [...gallery.querySelectorAll('.customsolo-d01-gallery__slide')];
      const previous = gallery.querySelector('[data-gallery-direction="previous"]');
      const next = gallery.querySelector('[data-gallery-direction="next"]');
      const status = gallery.querySelector('[role="status"]');
      const storage = (() => {try{return doc.defaultView?.sessionStorage;}catch{return null;}})();
      const key = 'customsolo.card-view.v1:' + (doc.location?.pathname || '') + ':' + (gallery.getAttribute?.('aria-label') || '');
      let index = -1;
      let gesture = null;
      let suppressClickUntil = 0;

      // Some cards have a full-card link above the image. Hit-test the photo
      // itself so that overlay never extends paddle hover into the copy area.
      function updatePhotoHover(event) {
        if (event.pointerType !== 'mouse') return;
        const rect = gallery.getBoundingClientRect();
        const over = event.clientX >= rect.left && event.clientX < rect.right &&
          event.clientY >= rect.top && event.clientY < rect.bottom;
        gallery.dataset.pointerOver = String(over);
      }
      card.addEventListener('pointerenter', updatePhotoHover);
      card.addEventListener('pointermove', updatePhotoHover);
      card.addEventListener('pointerleave', () => { gallery.dataset.pointerOver = 'false'; });

      function select(requested, remember = true) {
        const selected = Number.isInteger(requested) ? nextIndex(0, requested, slides.length) : 0;
        if (selected === index) return;
        index = selected;
        if(remember){try{storage?.setItem(key,String(index));}catch{}}
        track.style.transform = `translateX(${-index * 100}%)`;
        slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        status.textContent = `${slides[index].dataset.galleryLabel}, image ${index + 1} of ${slides.length}`;
        // Like the reference, move focus off the paddle that disappears at an end.
        if (doc.activeElement === previous && previous.disabled) next.focus({preventScroll:true});
        if (doc.activeElement === next && next.disabled) previous.focus({preventScroll:true});
      }

      let saved=0;try{saved=Number(storage?.getItem(key)||0);}catch{}
      select(saved,false);

      [previous, next].forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        if (!button.disabled) select(index + (button === next ? 1 : -1));
      }));
      gallery.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        event.stopPropagation();
        select(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });

      // The existing full-card product link remains intact. Listen on the card
      // so a swipe starting on that overlay can never become a product click.
      card.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' || event.isPrimary === false || event.target.closest('button:not(.customsolo-d01-card__link)')) return;
        const rect = gallery.getBoundingClientRect();
        if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) return;
        gesture = {id:event.pointerId, x:event.clientX, y:event.clientY, moved:false};
      });
      card.addEventListener('pointermove', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          gesture.moved = true;
          card.setPointerCapture(event.pointerId);
          if (event.cancelable) event.preventDefault();
        }
      });
      card.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const delta = swipeDelta(event.clientX - gesture.x, event.clientY - gesture.y);
        if (gesture.moved || delta) suppressClickUntil = Date.now() + 500;
        if (delta) select(index + delta);
        gesture = null;
      });
      card.addEventListener('pointercancel', () => { gesture = null; });
      card.addEventListener('click', event => {
        if (Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    });
  }
  return { init, nextIndex, swipeDelta };
});
